export default "__VITE_ASSET__e77fc960__"